import { render, staticRenderFns } from "./TermsUse.vue?vue&type=template&id=36e3c22b&scoped=true&"
import script from "./TermsUse.vue?vue&type=script&lang=js&"
export * from "./TermsUse.vue?vue&type=script&lang=js&"
import style0 from "./TermsUse.vue?vue&type=style&index=0&id=36e3c22b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e3c22b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VScrollYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VAlert,VScrollYTransition})
